import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './RegisterPage.css';

const RegisterPage = () => {
    const navigate = useNavigate();
    const { register } = useAuth();
    
    const [formData, setFormData] = useState({
        nom_complet: '',
        email: '',
        telephone: '',
        password: '',
        confirmPassword: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        // Validation
        if (!formData.nom_complet || !formData.email || !formData.password) {
            setError('Veuillez remplir tous les champs obligatoires');
            setLoading(false);
            return;
        }

        if (formData.password.length < 6) {
            setError('Le mot de passe doit contenir au moins 6 caractères');
            setLoading(false);
            return;
        }

        if (formData.password !== formData.confirmPassword) {
            setError('Les mots de passe ne correspondent pas');
            setLoading(false);
            return;
        }

        // Tentative d'inscription
        const result = await register({
            nom_complet: formData.nom_complet,
            email: formData.email,
            telephone: formData.telephone,
            password: formData.password
        });

        if (result.success) {
            navigate('/dashboard');
        } else {
            setError(result.message);
            setLoading(false);
        }
    };

    return (
        <div className="register-page">
            <div className="register-container">
                
                <div className="register-card">
                    {/* Logo */}
                    <div className="register-header">
                        <div className="register-logo">
                            <span className="logo-icon">🎓</span>
                        </div>
                        <h1>Créer un compte</h1>
                        <p>Accédez à toutes nos formations</p>
                    </div>

                    {/* Message d'information */}
                    <div className="info-message">
                        <span className="info-icon">💡</span>
                        <p>Vous pouvez aussi vous inscrire à une formation sans créer de compte. Un compte sera créé automatiquement après votre paiement.</p>
                    </div>

                    {/* Formulaire */}
                    <form onSubmit={handleSubmit} className="register-form">
                        
                        {error && (
                            <div className="error-message">
                                ⚠️ {error}
                            </div>
                        )}

                        <div className="form-group">
                            <label htmlFor="nom_complet">Nom complet *</label>
                            <input
                                type="text"
                                id="nom_complet"
                                name="nom_complet"
                                value={formData.nom_complet}
                                onChange={handleChange}
                                placeholder="Jean Dupont"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">Email *</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="votre@email.com"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="telephone">Téléphone</label>
                            <input
                                type="tel"
                                id="telephone"
                                name="telephone"
                                value={formData.telephone}
                                onChange={handleChange}
                                placeholder="0707123456"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">Mot de passe * (min. 6 caractères)</label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="••••••••"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="confirmPassword">Confirmer le mot de passe *</label>
                            <input
                                type="password"
                                id="confirmPassword"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                placeholder="••••••••"
                                required
                            />
                        </div>

                        <button type="submit" className="btn-register" disabled={loading}>
                            {loading ? 'Création du compte...' : 'Créer mon compte'}
                        </button>

                    </form>

                    {/* Login */}
                    <div className="register-footer">
                        <p>Vous avez déjà un compte ?</p>
                        <Link to="/login" className="link-login">
                            Se connecter
                        </Link>
                    </div>

                    {/* Ou continuer sans compte */}
                    <div className="divider">
                        <span>ou</span>
                    </div>

                    <button 
                        onClick={() => navigate('/formations')} 
                        className="btn-browse"
                    >
                        Parcourir les formations sans compte
                    </button>

                </div>

            </div>
        </div>
    );
};

export default RegisterPage;